import { mutations as TYPES } from "./types";
// import { defaultState } from "./state";

const mutations = {
  // [TYPES.DRAWER_RESET](state) {
  //   state = defaultState();
  // },
  [TYPES.TOGGLE_DRAWER](state, status = null) {
    if (status != null) {
      state.opening = status;
    } else {
      state.opening = !state.opening;
    }
  },
  [TYPES.UPDATE_WINDOW_SIZE](state, { height, width }) {
    state.windowHeight = height;
    state.windowWidth = width;
  },
  [TYPES.SET_DISPLAY_FEEDBACK](state, value) {
    state.displayFeedbackMsg = value;
  }
};

export default mutations;
